declare global {
  interface Window { brightlyVersion: string | undefined; }
}

let windowRef = globalThis.window;

const setWindowRef = (ref: Window & typeof globalThis) => {
  windowRef = ref;
};

const BRIGHTLY_VERSION_IDENTIFIER = '<BRIGHTLY_RELEASE_VERSION>'

function getPublicPath(): string {
  const version = windowRef.brightlyVersion;

  if (!version || version === BRIGHTLY_VERSION_IDENTIFIER) {
    return '/';
  }

  return `/${version}/`
}

__webpack_public_path__ = getPublicPath();
export { getPublicPath, BRIGHTLY_VERSION_IDENTIFIER, setWindowRef };
